import { useState, useEffect } from 'react'
import { UserRpps } from '@saas/interfaces/core'
import useDebounce from './useDebounce'
import { searchPhysicians } from '../utils/physicians'

/**
 * Hooks for RPPS Search
 * It uses /physicians from HDS
 * The research is based on first name, last name and rpps/adeli
 * @param {string} searchText text value in input field
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useSearchRpps = ({ searchText, codeprofession = undefined }: any) => {
    const [rppsUsers, setRppsUsers] = useState<{physicians: UserRpps[], count: number}>({physicians: [], count: 0})
    const [loading, setLoading] = useState(false)
    const [helper, setHelper] = useState(false)
    const debouncedSearchTerm = useDebounce(searchText, 800)

    useEffect(() => {
        let ignore = false

        const fetchRppsUsers = async () => {
            if (!debouncedSearchTerm.length) {
                setRppsUsers({physicians: [], count: 0})
                setLoading(false)
                setHelper(true)
            } else if (debouncedSearchTerm.length > 1) {
                setLoading(true)
                setHelper(false)
                const result = await searchPhysicians(debouncedSearchTerm, codeprofession)
                if (!ignore) {
                    const {physicians, count: totalPhysicians } = result
                    setRppsUsers({physicians, count: totalPhysicians})
                    setLoading(false)
                }
            }
        }

        fetchRppsUsers()

        return () => {
            ignore = true
        }
    }, [debouncedSearchTerm, codeprofession])

    return {
        rppsUsers,
        loading,
        helper
    }
}

export default useSearchRpps
